import React from 'react';
import { connect } from 'react-redux';

import SplashV3 from './splashV3';

const Splash = ({ splash, showSidebarLoader, show }) => {
    if (splash.show || showSidebarLoader || show) {
        return (
            <SplashV3 />
        );
    }
    return null;
};

function mapStateToProps({ splash }) {
    return { splash };
}

export default connect(mapStateToProps)(Splash);
